import { Box, Divider, List, ListItemButton, ListItemText, ListSubheader, Stack, styled } from "@mui/material";
import { COLOR_CONSTANTS } from "@/helpers/Colors";
import type { RfqBucket } from "../types";
import { RFQ_BUCKETS } from "../constants/buckets";

const CustomListItem = styled(ListItemButton)`
  &&.Mui-selected {
    color: ${COLOR_CONSTANTS["on-primary/variant"]};
    background-color: ${COLOR_CONSTANTS["primary/variant"]};
  }
`;

interface RfqBucketSidebarProps {
  counts: Partial<Record<RfqBucket, number>>;
  selected: RfqBucket;
  onSelect: (bucket: RfqBucket) => void;
}

export default function RfqBucketSidebar({ counts, selected, onSelect }: RfqBucketSidebarProps) {
  return (
    <Box
      sx={{
        width: 250,
        bgcolor: "background.paper",
        borderRadius: "8px",
        flexShrink: 0,
        maxHeight: "calc(100vh - 180px)",
        overflowY: "auto",
      }}
    >
      <List component="nav">
        <ListSubheader>RFQS</ListSubheader>
        <Divider />
        {RFQ_BUCKETS.map((bucket) => (
          <CustomListItem key={bucket.key} selected={selected === bucket.key} onClick={() => onSelect(bucket.key)}>
            <ListItemText
              primary={
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <div>{bucket.label}</div>
                  <div>{counts[bucket.key] ?? 0}</div>
                </Stack>
              }
            />
          </CustomListItem>
        ))}
      </List>
    </Box>
  );
}
